import type {
  ExtranetIncidentBackCategory,
  ExtranetIncidentOutput,
  IncidentCategory,
  IncidentPriority,
  IncidentStatus,
  IncidentSubCategory,
} from '../../types/extranet-api.types';

/**
 * Helpers d'accès ExtranetIncidentOutput → vue front "incident".
 *
 * Maintenant que le back livre le shape dédié extranet (Yohan 2026-06-17),
 * la plupart des helpers se réduisent à des accès directs aux champs.
 * On garde la couche pour le mapping `category` (back: 4 valeurs simplifiées
 * → front: 6 valeurs taxonomie spec §8.4) et la signature stable pour les
 * composants.
 */

export const getIncidentStatus = (incident: ExtranetIncidentOutput): IncidentStatus => incident.status;

export const getIncidentPriority = (incident: ExtranetIncidentOutput): IncidentPriority => incident.priority;

/**
 * Le back livre 4 catégories simplifiées (`security | driver_behavior |
 * technical | other`). Le front en a 6 (`pickup_delay | driver_absent |
 * security | vehicle | agent_pickup | communication`). Mapping pragmatique
 * en attendant que le back livre la taxonomie complète :
 */
const CATEGORY_BACK_TO_FRONT: Record<ExtranetIncidentBackCategory, IncidentCategory> = {
  security: 'security',
  driver_behavior: 'security', // sécurité élargie (RG-INC-2 : isSecurity inclus)
  technical: 'communication',
  other: 'communication',
};

export const getIncidentCategory = (incident: ExtranetIncidentOutput): IncidentCategory =>
  CATEGORY_BACK_TO_FRONT[incident.category] ?? 'communication';

export const getIncidentSubCategory = (_incident: ExtranetIncidentOutput): IncidentSubCategory | undefined => undefined;

export const getIncidentCity = (incident: ExtranetIncidentOutput): string => incident.city ?? '';

export const getIncidentEntityName = (incident: ExtranetIncidentOutput): string => incident.entityName ?? '';

export const getIncidentRideId = (incident: ExtranetIncidentOutput): string => incident.rideId ?? '';

export const getIncidentContractRef = (incident: ExtranetIncidentOutput): string => incident.contractRef ?? '';

/** Le back livre maintenant `createdAt` en ISO 8601 — on convertit en ms pour le tri. */
export const getIncidentCreatedAtMs = (incident: ExtranetIncidentOutput): number => {
  const ts = Date.parse(incident.createdAt);
  return Number.isNaN(ts) ? 0 : ts;
};
